import AssetTitle from "./asset-title";

export default AssetTitle;
